import { NEW_UI_PRIMARY_FILL_COLOR } from '../theme/colors';

export const AD_INFOS_LABEL_STYLE = {
  backgroundColor: NEW_UI_PRIMARY_FILL_COLOR,
  color: 'white'
};
